"use client";

import { memo, ReactNode } from "react";

import { useABtestContext } from "@/providers";

const UserFlowVariants = ({
  classic,
  redesign,
}: {
  classic: ReactNode;
  redesign: ReactNode;
}) => {
  const { AAB_Redesign } = useABtestContext();

  return AAB_Redesign ? redesign : classic;
};

export default memo(UserFlowVariants);
